import { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { INSURANCE_RELATED_PARTNERS_PATH } from "../utils/quote-funnel-redirect";

type props = {
    headerLabel?: string;
    label?: string;
    labelClass?: string;
    iconClass?: string;
    p1?: string;
    p2?: string;
    p3?: string;
    urlText?: string;
    url?: string;
};

const PRIVACY_POLICY_URL = "https://media.geico.com/legal/privacy_policy.htm";
const TERMS_OF_USE_URL = "https://media.geico.com/legal/terms_of_use.htm";
const PARTNERS_PATH = INSURANCE_RELATED_PARTNERS_PATH;

export const Disclaimer: FunctionComponent<props> = ({
    headerLabel,
    labelClass,
    iconClass,
}) => {
    return (
        <div className="disclaimer" style={{ padding: "3rem" }}>
            {iconClass && (
                <div>
                    <span className={`${iconClass} geico-icon disclaimer-icon`}></span>
                </div>
            )}
            <div className={labelClass}>
                {headerLabel && <label className="text bold">{headerLabel}</label>}
                <p className="disclaimer-paragraph">
                    The information you provide will be shared with selected insurance companies to obtain a policy.
                    If GEICO is unable to match you with one of our trusted partners, you may opt to be referred to
                    Commercial Insurance Center (&ldquo;CIC&rdquo;) to help find a commercial insurance solution for
                    your business. Your information will not be shared with CIC without your consent.
                </p>
                <p className="disclaimer-paragraph">
                    When you click on &ldquo;Start Quote,&rdquo; &ldquo;Continue,&rdquo; &ldquo;Start Your Quote Now,&rdquo;
                    or &ldquo;Next,&rdquo; you may be taken to the website of one of the insurance companies or
                    wholesalers with which GEICO Insurance Agency, LLC works. Please note that this website is not
                    owned or controlled by GEICO. The information you provide to GEICO will be shared with those
                    companies so that they can return a quote. Each insurer or wholesaler has sole financial
                    responsibility for its own products. GEICO has no control over the privacy practices of these
                    companies and assumes no responsibility in connection with your use of their websites. Any
                    information that you directly provide to one of these companies is subject to the privacy policy
                    posted on its website. All products offered are written on an admitted basis unless explicitly
                    noted that the quote offering is on non-admitted paper. Coverages are written through non-GEICO
                    insurance companies and are secured through GEICO Insurance Agency, LLC.
                </p>
                <p className="disclaimer-paragraph">
                    By entering my phone number, email address, and other information and clicking &ldquo;Continue,&rdquo;
                    I represent that I am at least 18 years old and provide my electronic signature. I agree that
                    GEICO Insurance Agency, LLC and its{" "}
                    <Link
                        to={PARTNERS_PATH}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="disclaimer-link"
                    >
                        insurance-related partners
                    </Link>{" "}
                    may contact me for marketing and telemarketing purposes at the phone number, including my
                    wireless number, and email address I provide, using live operators, an automatic telephone
                    dialing system (ATDS) and/or auto-dialer, prerecorded, artificial and/or AI-generated voice,
                    text messages and/or emails, even if the number I provided is on a company, state or Federal
                    Do Not Call registry. Consent is not a condition of purchase, and I may revoke consent at any
                    time. Message and data rates may apply. I expressly consent to my information being used and
                    disclosed as described in the{" "}
                    <a
                        href={PRIVACY_POLICY_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="disclaimer-link"
                    >
                        Privacy Policy
                    </a>
                    , and I agree to the{" "}
                    <a
                        href={TERMS_OF_USE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="disclaimer-link"
                    >
                        Terms and Conditions
                    </a>
                    .
                </p>
            </div>
        </div>
    );
};
